import React from 'react';
import { Text } from '@react-pdf/renderer';
import { getTaggedNoteText } from '@mummssoftware/utils/utils';
import { styles } from '../../../utils/styles';
export const MedNotesPDF = ({
  notes
}) => notes && notes.map(note => note.note && /*#__PURE__*/React.createElement(Text, {
  style: styles.fontSizeEightPt,
  key: note.id
}, `• ${getTaggedNoteText(note)}`));